import { clsx } from 'clsx';
import { useCallback, useEffect, useRef, useState } from 'react';
import { getAnimationDuration } from './helpers';
import styles from './Ticker.css';
import { jsx as _jsx } from "react/jsx-runtime";
/* Компонент бегущей строки */
export const Ticker = _ref => {
  let {
    text,
    theme,
    withoutPadding
  } = _ref;
  const wrapperRef = useRef(null);
  const tickerRef = useRef(null);
  const [animationDuration, setAnimationDuration] = useState(0);
  const [isInfinite, setInfinite] = useState(false);
  const [isStatic, setStatic] = useState(false);
  useEffect(() => {
    const time = getAnimationDuration(tickerRef.current, wrapperRef.current);
    if (!time) {
      setStatic(true);
    } else {
      setStatic(false);
      setAnimationDuration(time);
    }
  }, [text, isInfinite]);
  const onAnimationEnd = useCallback(() => {
    setInfinite(true);
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles['container'], isStatic && styles['container--static'], isInfinite && styles['container--infinite'], styles["container--".concat(theme)], withoutPadding && styles['container--without-padding']),
    ref: wrapperRef,
    children: /*#__PURE__*/_jsx("div", {
      className: styles['ticker'],
      ref: tickerRef,
      style: {
        WebkitAnimationDuration: "".concat(animationDuration, "s"),
        animationDuration: "".concat(animationDuration, "s")
      },
      onAnimationEnd: onAnimationEnd,
      children: /*#__PURE__*/_jsx("div", {
        className: styles['text'],
        children: text
      })
    })
  });
};